var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "inbox",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 30,
    height: 30,
    transform: "translate(1189 18)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-1189 -18)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M1641.468,617.716h-8.557a.713.713,0,0,0,0,1.426h8.557a.713.713,0,1,0,0-1.426Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M1638.616,620.568h-5.7a.714.714,0,0,0,0,1.427h5.7a.714.714,0,0,0,0-1.427Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M1645.033,624.847a1.427,1.427,0,0,1-1.426,1.426h-10.7a.712.712,0,0,0-.456.165l-3.109,2.592V616.29a1.427,1.427,0,0,1,1.426-1.426h12.835a1.427,1.427,0,0,1,1.426,1.426Zm-1.426-11.409h-12.835a2.855,2.855,0,0,0-2.852,2.852v14.261a.713.713,0,0,0,1.169.548l4.081-3.4h10.437a2.855,2.855,0,0,0,2.853-2.852V616.29A2.855,2.855,0,0,0,1643.607,613.438Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M1647.885,619.142a.713.713,0,1,0,0,1.426,1.428,1.428,0,0,1,1.426,1.427v12.063l-2.407-1.925a.718.718,0,0,0-.445-.156h-9.983a1.427,1.427,0,0,1-1.426-1.426v-.713a.713.713,0,0,0-1.426,0v.713a2.855,2.855,0,0,0,2.852,2.853h9.732l3.37,2.7a.714.714,0,0,0,1.16-.557V621.995A2.856,2.856,0,0,0,1647.885,619.142Z",
    transform: "translate(-433.92 -592.438)",
    fill: "#b5b5b5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.ce5b47813577881ae63b69b708dedd24.svg";
export { ForwardRef as ReactComponent };